module.exports = __webpack_public_path__ + "static/media/recycle.fedb190a.svg";